import { useSupplier } from "./api/v2/supplier/useSupplier";
import { useRemoteFeatureFlags } from "./useRemoteFeatureFlags";
import { useSellarCurrentBusiness } from "./useSellarCurrentBusiness.shared";

export const useDeliveryZoneMode = () => {
  const { business } = useSellarCurrentBusiness();
  const remoteFeatureFlags = useRemoteFeatureFlags();
  const modeAvailable =
    remoteFeatureFlags.isActive("basicDeliveryZoneMode") &&
    remoteFeatureFlags.isActive("unbundlingReleaseFinal");
  const supplierId = business?.Supplier?.id;
  const supplierQuery = useSupplier(supplierId, {
    enabled: modeAvailable && !!supplierId,
  });

  return {
    isBasicMode:
      modeAvailable &&
      supplierQuery.data?.advancedDeliveryZonesEnabled === false,
    isAdvancedMode:
      !modeAvailable ||
      supplierQuery.data?.advancedDeliveryZonesEnabled === true,
    isLoading: modeAvailable && supplierQuery.isLoading,
    modeAvailable,
    supplierQuery,
  };
};
